import React from 'react'
import PropTypes from 'prop-types'
import { Controller, useForm } from 'react-hook-form'
import SydModal from '../../../../commonDesign/SydModal'
import SydLabel from '../../../../commonDesign/SydLabel'
import SydInput from '../../../../commonDesign/SydInput'
import SaveCancelButtons from '../../../../molecules/SaveCancelButtons'
import { useCreatePersonTypeMutation } from '../../../../../api/people'
import SnackAlert from '../../../../molecules/SnackAlert/SnackAlert'

const PersonTypeModal = ({ open, onClose }) => {
  const [error, setError] = React.useState(null)
  const form = useForm({
    defaultValues: {
      longName: '',
      shortName: '',
      description: '',
      ordinal: 0,
      depth: 0
    }
  })
  const { mutateAsync: createPersonType, isLoading } = useCreatePersonTypeMutation()
  const onSubmit = async (data) => {
    const command = {
      longName: data.longName,
      shortName: data.shortName,
      description: data.description,
      ordinal: data.ordinal,
      depth: data.depth
    }
    try {
      await createPersonType(command)
      onClose()
    } catch (error) {
      setError({ alertMessage: 'Error creating person type', openAlert: true, alertSeverity: 'error' })
    }
  }
  return (
    <SydModal title='Person Type' open={open} onClose={onClose}>
      <form className='form flex flex-col gap-md'>
        <div className='flex flex-row gap-md'>
          <Controller
            control={form.control}
            name='longName'
            rules={{
              required: true
            }}
            render={({ field, fieldState }) => (
              <SydLabel label='Name' required error={fieldState.error?.message}>
                <SydInput size='sm' {...field} />
              </SydLabel>
            )}
          />
          <Controller
            control={form.control}
            name='shortName'
            rules={{
              required: true
            }}
            render={({ field, fieldState }) => (
              <SydLabel label='Code' required error={fieldState.error?.message}>
                <SydInput size='sm' {...field} />
              </SydLabel>
            )}
          />
        </div>
        <div className='flex flex-row gap-md'>
          <Controller
            control={form.control}
            name='description'
            render={({ field }) => (
              <SydLabel label='Description'>
                <SydInput size='sm' {...field} />
              </SydLabel>
            )}
          />
          <Controller
            control={form.control}
            name='ordinal'
            render={({ field }) => (
              <SydLabel label='Ordinal'>
                <SydInput type='number' size='sm' {...field} />
              </SydLabel>
            )}
          />
        </div>
        <div className='flex flex-row gap-md'>
          <Controller
            control={form.control}
            name='depth'
            render={({ field }) => (
              <SydLabel label='Family Tree Depth'>
                <SydInput type='number' size='sm' {...field} />
              </SydLabel>
            )}
          />
        </div>
      </form>
      <SnackAlert alert={error} />
      <div className='flex flex-row justify-center'>
        <SaveCancelButtons onCancel={onClose} onSave={form.handleSubmit(onSubmit)} isSubmitting={isLoading} />
      </div>
    </SydModal>
  )
}

PersonTypeModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func
}
export default PersonTypeModal
